<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import customerApi from '@/services/customers/customer.api'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'side-menu-customers-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    detailFormatter(cell) {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    }
  },
  mounted() {
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function(url, config, params) {
        console.log(url)
        console.log(params)
        console.log(config)
        return customerApi.getList(params.page, params.size, params.filter)
      },
      ajaxResponse: function(url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      filterMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.personName'),
          minWidth: 200,
          headerSort: false,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          headerFilter: 'input',
          headerFilterPlaceholder: this.$t('table.search.lastname'),
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">
                ${cell.getData().name} ${cell.getData().lastname}
                </div>
              </div>`
          }
        },
        {
          title: 'Email',
          minWidth: 200,
          headerSort: false,
          responsive: 0,
          field: 'email',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">
                ${cell.getData().email}
                </div>
              </div>`
          }
        },
        {
          title: this.$t('common.phoneNumber'),
          minWidth: 200,
          headerSort: false,
          responsive: 0,
          field: 'phoneNumber',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">
                ${cell.getData().phoneNumber}
                </div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        }
      ]
    })
  }
})
</script>
